import React, { useState } from "react";

const Faqs = () => {
  const [selectedQuestion, setSelectedQuestion] = useState(null);

  // Sample FAQ data - replace this with your actual data
  const faqData = [
    {
      question: "What is Fynii?",
      answer:
        "An online platform to provide instant solutions to conceptual, technical and practical problems in science, technology, engineering and mathematics using a human plus machine approach.",
    },
    {
      question: "Who can use it?",
      answer:
        "Fynii is useful to anyone from an absolute beginner to a working professional. From getting solutions to any topic in science, technology, engineering and mathematics to help build real-world projects and products.",
    },
    {
      question: "How to get a solution to a problem?",
      answer:
        "You can get a solution by booking a live one-to-one session with a problem solver in an instant or pre-scheduled mode. <br><br> The other way to get a solution to your problem is by using the Generative AI tool MagicAI.",
    },

    {
      question: "Who is a problem solver?",
      answer:
        "We call our teachers problem solvers because they are passionate about solving problems in their respective topics. A selection of a problem solver is rigorous, and therefore, you will get a better experience.",
    },
    {
      question: "What is a one-to-one session?",
      answer:
        "A live one-to-one session is one in which you get solutions to your problems in an instant or a pre-scheduled session mode. You first select the category for your problem and then choose the topic that you want a solution. You then select a problem solver of your choice and book a session by putting your problem and selecting the available date and time. For Instant sessions, you just need to click request to join after putting your problem with the available problem solver. You will see availability on the card of the problem solver.",
    },

    {
      question: "What is MagicAI?",
      answer:
        "MagicAI is a Generative AI solution. It is a powerful fine-tuned and domain specific large language model (LLM) based on technologies like Deep learning and Machine learning to solve STEM (science, technology, engineering and mathematics) problems instantly with accuracy. <br><br>Generative AI solutions are the tool with the most advanced technology that helps in generating responses in the form of text, image, code, solution, reasoning, etc., to natural prompts (input). You can instantly solve your STEM problems with greater accuracy like magic.",
    },
    {
      question: "What is a large language model?",
      answer:
        "A large language model or LLM in short, refers to large, general-purpose language models that can be pre-trained and then fine-tuned for a specific purpose.",
    },
    {
      question: "What is a prompt?",
      answer:
        "A prompt is a piece of text (natural language) given to the LLM as input.",
    },
    {
      question: " What are the benefits of using Fynii?",
      answer:
        "Benefits range from getting help in building real-world projects & products, clearing an exam, upskilling the most in-demand skills, understanding a subject better and cracking a tech interview round in science, technology, engineering and mathematics.",
    },
    {
      question: "What is the pricing?",
      answer:
        "We have set the minimum possible pricing for live one-to-one sessions. You can check more details by clicking on the pricing tab in the footer.<br><br> MagicAI will be limited to use for only two prompts in a single day for 30 days for a free account. For unlimited use of MagicAI, you will take a subscription to use its problem-solving capabilities. Subscriptions will be monthly and annually.",
    },

    {
      question: "Can I use Fynii for free?",
      answer:
        "We have set the minimum possible price so that anyone can afford it. However, if you feel you cannot afford it, you can apply by clicking here for a financial aid.",
    },

    // Add more quesitons
  ];

  const handleQuestionClick = (index) => {
    setSelectedQuestion(index === selectedQuestion ? null : index);
  };
  return (
    <div className="lg:mx-44 flex flex-col items-center bg-black text-white rounded-lg  ">
      <h1 className="text-3xl text-white mt-7 mb-2 lg:text-4xl font-bold ">
        FAQs
      </h1>
      <div className="flex flex-col lg:flex-row w-full">
        <div className="w-full lg:w-1/2 p-5 lg:border-r lg:border-b-0">
          {faqData.map((item, index) => (
            <div
              key={index}
              className={`cursor-pointer p-4 mb-2 border rounded-md ${
                index === selectedQuestion
                  ? "bg-white text-black font-bold"
                  : "bg-black text-white font-normal"
              }`}
            >
              <div onClick={() => handleQuestionClick(index)}>
                {item.question}
              </div>
              <div
                className={`font-normal mt-2 lg:hidden`}
                dangerouslySetInnerHTML={{
                  __html:
                    selectedQuestion === index
                      ? faqData[selectedQuestion].answer
                      : "",
                }}
              ></div>
            </div>
          ))}
        </div>

        {/* Show this div only in tablet and desktop view (lg and md), not in mobile view (sm) */}
        <div className="hidden lg:w-1/2 lg:flex p-5 justify-center items-center bg-white text-black lg:m-5 border rounded-md lg:justify-start lg:items-start">
          {selectedQuestion !== null && (
            <div
              className="font-normal"
              dangerouslySetInnerHTML={{
                __html: faqData[selectedQuestion].answer,
              }}
            ></div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Faqs;
